import { Box, NoticeBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import Item from './Item'

interface Props {
  plannedBreaks: PlannedBreak[]
  canManage: boolean
  shift?: Shift
  showDeleted?: boolean
  newVersion?: boolean
}

const PlannedBreaks = ({
  plannedBreaks,
  canManage,
  shift,
  showDeleted = false,
  newVersion = false,
}: Props) => {
  const sortedBreaks = plannedBreaks.sort((a, b) =>
    a.id.localeCompare(b.id, undefined, { numeric: true })
  )

  if (newVersion) {
    return (
      <Box flexDirection="column" gap="s16">
        {sortedBreaks.map((plannedBreak) => {
          return (
            <Item
              key={plannedBreak.id}
              plannedBreak={plannedBreak}
              shift={shift}
              canManage={canManage}
              newVersion={newVersion}
              showDeleted={showDeleted}
            />
          )
        })}
      </Box>
    )
  }

  return (
    <Box gap="s8">
      <Text size="200" color="grey1000">
        {i18n.t('shift_management.shift_details_modal.breaks_added')}
      </Text>
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{ all: 'abs008' }}
        padding="s16"
        gap="s16"
        flexDirection="row"
      >
        <Box flexDirection="column" gap="s16">
          {sortedBreaks.map((plannedBreak) => {
            if (plannedBreak.breakConfiguration?.archived && showDeleted) {
              return (
                <NoticeBox
                  key={plannedBreak.id}
                  message={i18n.t('shift_management.planned_breaks.archived.was_deleted', {
                    name: plannedBreak.breakConfiguration?.name,
                  })}
                  borderRadius={{ all: 'abs008' }}
                />
              )
            } else {
              return (
                <Item
                  key={plannedBreak.id}
                  plannedBreak={plannedBreak}
                  shift={shift}
                  canManage={canManage}
                />
              )
            }
          })}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(PlannedBreaks)
